// UC14 Phase 5.3: goi proxy qlvb-be /api/step-up/challenge|verify (auth token qlvb-be nhu API thuong,
// header "Token" da gan san boi HTTP instance - xem src/api/http-common.js). qlvb-be forward sang
// common-be internal (X-Internal-Key + userId tu claim), KHONG lien quan token common-be.
import ENDPOINT from "@/api/endpoints";
import { HTTP } from "@/api/http-common";

/**
 * Xin challenge OTP step-up cho 1 thao tac (TrinhKy/PheDuyet/ThuHoi).
 * @param {{actionType: string, resourceId?: string, resourceIds?: string[]}} payload
 */
export function callApiStepUpChallenge(payload) {
  return HTTP({
    url: ENDPOINT.STEP_UP.CHALLENGE,
    method: "POST",
    data: payload,
  });
}

/**
 * Xac thuc OTP step-up, tra ve stepUpToken dung 1 lan cho thao tac tuong ung.
 * @param {{challengeId: string, actionType: string, resourceId?: string, resourceIds?: string[], otp: string, deviceId?: string}} payload
 */
export function callApiStepUpVerify(payload) {
  return HTTP({
    url: ENDPOINT.STEP_UP.VERIFY,
    method: "POST",
    data: payload,
  });
}
